var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-echart section-margin-top"},[(_vm.isLoading)?_c('div',{staticClass:"loading-tips"}):(_vm.isEmpty)?_c('div',{staticClass:"empty-tips"}):_c('v-chart',{staticStyle:{"width":"100%","height":"400px"},attrs:{"autoresize":true,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }